<template>
  <main class="centerBox">
    <section class="whiteBox" style="width: 35%;">
      <div class="row logo">
        <img src="@/assets/images/logo.png" alt="logo" />
      </div>
      <div class="content">
        <h1>{{$t('forgot.title')}}</h1>
      </div>
      <hr />
      <!-- -->
      <div v-if="showReinitialization">
        <div class="content">
          <div style="padding-left:10px;padding-right:10px;padding-bottom:10px;text-align: center;">
            <label>{{$t('forgot.chooseNewPassword')}}</label>
            <div> 
            <h1>{{email}}</h1></div>
          </div>
          <div class="column">
            <div class="row spaceBetween">
              <label>{{$t('forgot.newPassword')}}</label>
               <p
                class="errorSentence"
                v-if="showReinitializationError">{{$t('error.reinitializationError')}}</p>
              <p
                class="errorSentence"
                v-if="!passwordFormat && isSubmitted"
              >{{$t('error.invalidPassword')}}</p>
            </div>
            <div class="rowIn">
              <input
                :type="inputClass"
                :class="{ 'error' : !passwordFormat && isSubmitted }"
                v-model="password"
              />
              <span
                @mousedown="displayPassword"
                @mouseup="hidePassword"
                @mouseleave="hidePassword"
                :class="toggleClass"
              ></span>
            </div>
          </div>
        </div>
        <hr />
        <div class="content">
          <button @click="reinitialization">{{$t('button.reinitializationPassword')}}</button>
          <router-link :to="{name: 'login'}">{{$t('button.cancel')}}</router-link>
        </div>
      </div>
      <!-- -->
      <div v-if="showReinitializationSuccessful">
          <div  class="content" style="text-align:center;" >
          <img src="@/assets/images/new_password.png"  width="25%" height="25%"/>
          <p style="text-align:center;">{{$t('forgot.yourPasswordHasBeenReinitialized')}} </p>
             <div class="spacer-10"></div>
             <p style="text-align:center;">{{$t('forgot.youCanUseToConnect')}}</p>
           <hr />
          </div>
        <div class="content">
          <button @click="$router.push({name: 'login'})">{{$t('button.login')}}</button>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import passwordManagement from "@/mixins/passwordManagement";
import Login from "@/services/Login";

export default {
  mixins: [passwordManagement],
  data() {
    return {
      password: "",
      email:"",
      isSubmitted: false,
      showReinitialization: true,
      showReinitializationError:false,
      showReinitializationSuccessful: false
    };
  },
  computed: {
    passwordFormat: function() {
      return this.checkPassword(this.password);
    }
  },
  mounted(){
    Login.getUserByToken(this.$route.params.token).then(res =>{
      if(res.status == 200){
        this.email = res.data["email"];
      }
    }).catch(() =>{
            this.showReinitializationError =  true;
            });
  },
  methods: {
    reinitialization() {
      this.isSubmitted = true;
      if(this.passwordFormat){
          this.showReinitialization = false;
          Login.partialUpdatePassword(this.$route.params.token,{"password":this.password}).then(res => {
            if(res.status == 204){
              this.showReinitializationSuccessful = true;
            }
          }).catch(() => {
            this.showReinitialization =  true;
            this.showReinitializationError =  true;
          })
      }
    }
  }
};
</script>
<style scoped>
.logo {
  background: #f1f1f1;
  display: flex;
  justify-content: center;
  padding-bottom: 10%;
}
.field-icon {
  margin-left: -25px;
  z-index: 2;
}
.blue {
  color: #2e75d0;
}
.demiRowIn {
  display: "inline-flex";
  width: 50%;
  margin: 5px 0px;
}
.rowIn {
  display: "inline-flex";
  width: 100%;
  margin: 5px 0px;
}
</style>